<template>
  <div style="padding-right: 2rem;">
    <policy-detail />
    <!-- <task-detail @onSave="reloadAll" @onDelete="reloadAll" /> -->
    <task-detail />

    <div class="d-flex justify-content-between w-100" style="margin-bottom: 1.70rem;">
      <div class="d-flex align-items-center w-50" style="gap: 2.34rem;">
        <div class="search2" v-if="viewType === 'kanban'">
          <div class="search2--icon"><i class="iconoir-search"></i></div>
          <input class="search2--input" type="text" :placeholder="$t('task.search')" v-model="nameFilter" />
        </div>
        <div v-if="viewType === 'list'">
          <select v-model="dateField" class="form-control">
            <option selected value="createdAt">{{ $t("common.created-at") }}</option>
            <option value="updatedAt">{{ $t("common.lastUpdateDate") }}</option>
            <option value="duedate">{{ $t("task.duedate") }}</option>
            <option value="donedate">{{ $t("task.donedate") }}</option>
          </select>
        </div>
        <div v-if="viewType === 'list'" class="w-40">
          <date-picker v-model="rangeDate" range :placeholder="$t('common.date')" @change="setDateValue" :lang="currentLanguage"> </date-picker>
        </div>
        <!-- TKP-165 / tunesoftgorevler s.3 md.3: üstteki "Tüm Ürünler" ürün seçimi kalktı (TKP-118 kararı güncellendi); liste ürün süzgeci olmadan gider -->
      </div>
      <div class="d-flex align-items-center">
        <b-dropdown v-if="isDownloadEnabled" split split-href="#" :text="$t('task.download-options')" size="sm" variant="light" class="m-2">
          <b-dropdown-item @click="downloadExcel" href="#">{{ $t("common.download") }}</b-dropdown-item>
        </b-dropdown>

        <div v-if="scope !== 'ACCOUNT'" class="new-task-text" @click="openNewTaskModal">{{ $t("task.create") }}</div>
        <div v-if="scope !== 'ACCOUNT'" class="plus-button" style="margin-right: 1.56rem;" @click="openNewTaskModal"></div>
        <div class="view-button-container">
          <button class="view-button" :class="{ active: viewType === 'list' }" @click="viewType = 'list'"><i class="iconoir-table-rows"></i></button>
          <button class="view-button" :class="{ active: viewType === 'kanban' }" @click="viewType = 'kanban'"><i class="iconoir-view-columns-3"></i></button>
        </div>
        <!-- TKP-165 md.2: arşiv geçişi kalktı — arşiv sol menüden (Arşivlenen Görevler) -->
      </div>
    </div>
    <div v-if="activeTab === 'organization'" class="organization-members w-100" style="padding: 0;">
      <div class="organization-members--items d-flex flex-wrap mb-3" style="min-height: 40px;">
        <div
          v-for="(member, index) in organizationMembers"
          :key="member._id"
          @click="applyMemberFilter(member)"
          class="organization-members--item ml-1 mt-1 mb-1"
          :class="member.selected ? 'selected' : ''"
          :style="{ left: `${index + 1 + index * 0.2}rem` }"
        >
          <task-avatar :account="member" size="xs" />
        </div>
      </div>
    </div>
    <nav class="tab-menu" v-if="scope !== 'ACCOUNT'">
      <div :class="{ active: activeTab === 'account' }" @click="activeTab = 'account'">{{ $t("task.my") }}</div>
      <div v-if="hasOrganizationTaskViewPermission" :class="{ active: activeTab === 'organization' }" @click="activeTab = 'organization'">
        {{ $t("task.organization") }}
      </div>
    </nav>
    <!-- TKP-164: analiz sekmesi sol menüdeki Dashboard'a taşındı (/tasks/dashboard) -->
    <div v-if="viewType === 'kanban'" class="tab-content">
      <div :class="{ active: activeTab === 'account' }">
        <content-loading v-if="isMyTasksLoading" />
        <kanban-view v-else :type="activeTab" :tasks="myTasks" />

        <div v-if="myTasksPagination" class="row">
          <div class="col">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination v-model="myTasksRequest.options.page" :total-rows="myTasksPagination.totalDocs" :per-page="myTasksPagination.limit" limit="10" size="sm"></b-pagination>
            </ul>
          </div>
        </div>
      </div>
      <div :class="{ active: activeTab === 'organization' }">
        <content-loading v-if="isOrganizationTasksLoading" />
        <kanban-view v-else :type="activeTab" :tasks="organizationTasks" />

        <div v-if="organizationTasksPagination" class="row">
          <div class="col">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination
                v-model="organizationTasksRequest.options.page"
                :total-rows="organizationTasksPagination.totalDocs"
                :per-page="organizationTasksPagination.limit"
                limit="10"
                size="sm"
              ></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="tab-content">
      <div :class="{ active: activeTab === 'account' }">
        <div>
          <list-view
            id="account"
            :scope="scope"
            :activeTab="activeTab"
            :name="nameFilter"
            @nameFilter="nameFilter = $event"
            @noFilter="noFilter = $event"
            :description="descriptionFilter"
            @descriptionFilter="descriptionFilter = $event"
            :status="statusFilter"
            @statusFilter="statusFilter = $event"
            :organization="organizationFilter"
            @organizationFilter="organizationFilter = $event"
            :account="accountFilter"
            @accountFilter="accountFilter = $event"
            :priority="priorityFilter"
            @priorityFilter="priorityFilter = $event"
            :category="categoryFilter"
            @categoryFilter="categoryFilter = $event"
            :type="typeFilter"
            @typeFilter="typeFilter = $event"
            :duedate="duedateFilter"
            @duedateFilter="duedateFilter = $event"
            :createdAtSort="createdAtSort"
            @createdAtSort="createdAtSort = $event"
            :createdAt="createdAtFilter"
            @createdAtFilter="createdAtFilter = $event"
          />

          <empty v-if="!myTasksPagination || myTasksPagination.docs.length == 0">
            <h5 class="text-center">
              {{ $t("data.no-data") }}
            </h5>
          </empty>

          <!-- Begin: Pagination -->

          <div v-if="myTasksPagination" class="row">
            <div class="col">
              <ul class="pagination pagination-rounded mb-0">
                <b-pagination
                  v-model="myTasksRequest.options.page"
                  :total-rows="myTasksPagination.totalDocs"
                  :per-page="myTasksPagination.limit"
                  limit="10"
                  size="sm"
                ></b-pagination>
              </ul>
            </div>
          </div>
          <!-- End: Pagination -->
        </div>
      </div>
      <div :class="{ active: activeTab === 'organization' }">
        <div>
          <list-view id:="organization" :scope="scope" :activeTab="activeTab" :name="nameFilter" @nameFilter="nameFilter = $event" @noFilter="noFilter =$event"
          :description="descriptionFilter" @descriptionFilter="descriptionFilter = $event" :status="statusFilter" @statusFilter="statusFilter = $event" :account="accountFilter"
          @accountFilter="accountFilter = $event" :organization="organizationFilter" @organizationFilter="organizationFilter = $event"
          :priority="priorityFilter" @priorityFilter="priorityFilter = $event" :category="categoryFilter" @categoryFilter="categoryFilter = $event"
          :type="typeFilter" @typeFilter="typeFilter = $event"
          :duedate="duedateFilter" @duedateFilter="duedateFilter = $event" :createdAtSort="createdAtSort" @createdAtSort="createdAtSort = $event" :createdAt="createdAtFilter" @createdAtFilter="createdAtFilter = $event" />

          <empty v-if="!organizationTasksPagination || organizationTasksPagination.docs.length == 0">
            <h5 class="text-center">
              {{ $t("data.no-data") }}
            </h5>
          </empty>

          <!-- Begin: Pagination -->

          <div v-if="organizationTasksPagination" class="row">
            <div class="col">
              <ul class="pagination pagination-rounded mb-0">
                <b-pagination
                  v-model="organizationTasksRequest.options.page"
                  :total-rows="organizationTasksPagination.totalDocs"
                  :per-page="organizationTasksPagination.limit"
                  limit="10"
                  size="sm"
                ></b-pagination>
              </ul>
            </div>
          </div>
          <!-- End: Pagination -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@modules/websocket";
import { applyPatch, categoryPatch, createdRangePatch, dueRangePatch, exportPagination, priorityPatch, sortPatch, typePatch } from "@/modules/task/task-filters"; // TKP-165, TKP-176, TKP-181
import PolicyDetail from "../policy/component/policy-detail";

import DatePicker from "vue2-datepicker";
import KanbanView from "./tasks-kanban-view";
import ListView from "./tasks-list-view";

export default {
  props: ["scope"],
  components: { KanbanView, ListView, PolicyDetail, DatePicker },
  data() {
    return {
      dateField: "createdAt",
      rangeDate: [],
      organizationTasksRequest: {
        options: { page: 1, limit: 15, sort: { priority: "desc", no: "asc" } },
        query: {},
      },
      myTasksRequest: {
        options: { page: 1, limit: 15, sort: { priority: "desc", no: "asc" } },
        query: {},
      },
      nameFilter: undefined,
      noFilter: undefined,
      descriptionFilter: undefined,
      accountFilter: undefined,
      statusFilter: undefined,
      organizationFilter: undefined,
      // TKP-165 md.4: öncelik / kategori / son tarih sütun süzgeçleri; TKP-176 md.50: oluşturma tarihi sıralaması
      priorityFilter: null,
      categoryFilter: null,
      typeFilter: null, // TKP-240 b.2
      duedateFilter: [],
      createdAtSort: null,
      createdAtFilter: [], // TKP-181 md.50
      ////
      viewType: "list", // TKP-165 md.1: varsayılan satır görünümü; kanban tuşla (URL viewType parametresi çalışır)
      activeTab: "account",
    };
  },

  computed: {
    hasOrganizationTaskViewPermission() {
      if (this.currentAccountCan("TASK_TASKS__HAS_ORGANIZATION_TASK_VIEW_PERMISSION")) {
        return true;
      }

      return false;
    },


    organizationMembers() {
      return this.$store.getters["organizationMember/accesableOrganizationMembers"] ?? [];
    },
    isDownloadEnabled() {
      if (this.activeTab == "account") {
        return this.myTasksPagination && this.myTasksPagination.docs.length > 0;
      } else {
        return this.organizationTasksPagination && this.organizationTasksPagination.docs.length > 0;
      }
    },
    myTasks() {
      return this.myTasksPagination?.docs ?? [];
    },
    myTasksPagination() {
      return this.$store.getters["task/myTasksPagination"];
    },
    organizationTasks() {
      return this.organizationTasksPagination?.docs ?? [];
    },
    organizationTasksPagination() {
      return this.$store.getters["task/organizationTasksPagination"];
    },
    isOrganizationTasksLoading() {
      return this.$store.getters["task/isOrganizationTasksLoading"];
    },
    isMyTasksLoading() {
      return this.$store.getters["task/isMyTasksLoading"];
    },
  },

  watch: {
    // TKP-239 g.9: aynı ekrandayken /tasks/<id> adresine geçilirse de görev açılır (bileşen yeniden kurulmaz)
    "$route.params.id"() {
      this.openTaskFromRoute();
    },
    dateField(n, o) {
      if ((n, n != o)) {
        this.clearDateFilter();
      }
    },
    organizationTasksRequest: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginateOrganizationTasks(), "organization");
      },
    },

    myTasksRequest: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginateMyTasks(), "my");
      },
    },
    nameFilter(n, o) {
      const localizedField = "name." + this.currentLanguage; //only for myTaskRequest
      if (n) {
        this.organizationTasksRequest.query = { ...this.organizationTasksRequest.query, name: { value: n } };

        this.myTasksRequest.query = { ...this.myTasksRequest.query, [localizedField]: { value: n } };
      } else {
        this.organizationTasksRequest.query["name"] = null;
        delete this.organizationTasksRequest.query["name"];

        this.myTasksRequest.query[localizedField] = null;
        delete this.myTasksRequest.query[localizedField];
      }
    },
    noFilter(n, o) {
      if (n) {
        const isNumber = !isNaN(n);
        if (!isNumber) {
          this.clearNoFilter();
        }
        this.organizationTasksRequest.query = { ...this.organizationTasksRequest.query, ...(isNumber ? { no: { value: n, isObject: true } } : {}) };

        this.myTasksRequest.query = { ...this.myTasksRequest.query, ...(isNumber ? { no: { value: n, isObject: true } } : {}) };
      } else {
        this.clearNoFilter();
      }
    },

    descriptionFilter(n, o) {
      const localizedField = "description." + this.currentLanguage; //only for myTaskRequest
      if (n) {
        this.organizationTasksRequest.query = { ...this.organizationTasksRequest.query, description: { value: n } };

        this.myTasksRequest.query = { ...this.myTasksRequest.query, [localizedField]: { value: n } };
      } else {
        this.organizationTasksRequest.query["description"] = null;
        delete this.organizationTasksRequest.query["description"];

        this.myTasksRequest.query[localizedField] = null;
        delete this.myTasksRequest.query[localizedField];
      }
    },
    statusFilter(n, o) {
      if (n) {
        this.organizationTasksRequest.query = { ...this.organizationTasksRequest.query, status: { value: n, isObject: true } };

        this.myTasksRequest.query = { ...this.myTasksRequest.query, status: { value: n, isObject: true } };
      } else {
        this.organizationTasksRequest.query["status"] = null;
        delete this.organizationTasksRequest.query["status"];

        this.myTasksRequest.query["status"] = null;
        delete this.myTasksRequest.query["status"];
      }
    },
    priorityFilter(n) {
      this.applyColumnFilter(priorityPatch(n), ["priority"]);
    },
    categoryFilter(n) {
      this.applyColumnFilter(categoryPatch(n), ["category"]);
    },
    typeFilter(n) {
      this.applyColumnFilter(typePatch(n), ["type"]); // TKP-240 b.2
    },
    duedateFilter(n) {
      this.applyColumnFilter(dueRangePatch(n), ["duedate"]);
    },
    createdAtFilter(n) {
      // TKP-181 md.50: sütun süzgeci (üstteki tarih aralığı "Oluşturulma Tarihi"ndeyken aynı anahtarı yazar — son yapılan geçerli)
      this.applyColumnFilter(createdRangePatch(n), ["createdAt"]);
    },
    createdAtSort(n) {
      // TKP-176 md.50: başlık sıralaması iki isteğe; kapalıyken varsayılan (öncelik, numara)
      this.organizationTasksRequest.options = { ...this.organizationTasksRequest.options, sort: sortPatch(n) };
      this.myTasksRequest.options = { ...this.myTasksRequest.options, sort: sortPatch(n) };
    },
    organizationFilter(n, o) {
      if (n) {
        this.myTasksRequest.query = { ...this.myTasksRequest.query, organization: { value: n, isObject: true } };
      } else {
        this.myTasksRequest.query["organization"] = null;
        delete this.myTasksRequest.query["organization"];
      }
    },
    accountFilter: {
      deep: true,

      handler(n, o) {
        if (n) {
          this.organizationTasksRequest.query = { ...this.organizationTasksRequest.query, assignee: { value: n, isObject: true } };
        } else {
          this.organizationTasksRequest.query["assignee"] = null;
          delete this.organizationTasksRequest.query["assignee"];

          this.myTasksRequest.query["assignee"] = null;
          delete this.myTasksRequest.query["assignee"];
        }
      },
    },
  },
  mounted() {
    EventBus.$on("task-board-update", (e) => {
      this.reloadAll();
    });

    this.handleQueryParams();
    this.openTaskFromRoute(); // TKP-239 g.9: e-postadaki "buraya" bağlantısı (/tasks/<id>) görevi doğrudan açar

    this.$store.dispatch("organizationMember/paginateWith", { pagination: {}, organizationId: this.currentOrganization._id });
  },

  methods: {
    setDateValue(item) {
      this.rangeDate = item;

      if (item && item.length == 2 && !item.includes(null)) {
        const startTime = new Date(this.rangeDate[0]).setHours(0, 0, 0, 0);
        const endTime = new Date(this.rangeDate[1]).setHours(23, 59, 59, 999);

        this.organizationTasksRequest = {
          ...this.organizationTasksRequest,
          query: { ...this.organizationTasksRequest.query, [this.dateField]: { value: { $gte: startTime, $lte: endTime }, isObject: true } },
        };

        this.myTasksRequest = {
          ...this.myTasksRequest,
          query: { ...this.myTasksRequest.query, [this.dateField]: { value: { $gte: startTime, $lte: endTime }, isObject: true } },
        };
      } else {
        this.clearDateFilter();
      }
    },
    clearNoFilter() {
      this.organizationTasksRequest.query["no"] = null;
      delete this.organizationTasksRequest.query["no"];

      this.myTasksRequest.query["no"] = null;
      delete this.myTasksRequest.query["no"];
    },
    clearDateFilter() {
      this.organizationTasksRequest.query.createdAt = null;
      this.organizationTasksRequest.query.updatedAt = null;
      this.organizationTasksRequest.query.duedate = null;
      this.organizationTasksRequest.query.donedate = null;

      delete this.organizationTasksRequest.query.createdAt;
      delete this.organizationTasksRequest.query.updatedAt;
      delete this.organizationTasksRequest.query.duedate;
      delete this.organizationTasksRequest.query.donedate;
      this.rangeDate = [];
    },
    async paginateOrganizationTasks() {
      if (!this.hasOrganizationTaskViewPermission) return;

      await this.$store.dispatch("task/fetchOrganizationTasks", this.organizationTasksRequest);
    },
    async paginateMyTasks() {
      let payload = {
        ...this.myTasksRequest,
        query: {
          ...this.myTasksRequest.query,
          organization: { value: this.organizationFilter?._id ? this.organizationFilter : this.currentOrganization?._id, isObject: true },
        },
      };
      if (this.scope === "ACCOUNT") {
        if (!this.organizationFilter?._id) {
          delete payload.query.organization;
        }
      }

      await this.$store.dispatch("task/fetchCurrentUserAssignedTask", payload);
    },
    // TKP-118: arşiv tek yerde — modül ekranı `/tasks/archived`, kullanıcı paneli `/account/tasks/archived`.
    applyMemberFilter(member) {
      if (member.selected) {
        member.selected = false;
        this.organizationTasksRequest = {
          ...this.organizationTasksRequest,
          query: {
            ...this.organizationTasksRequest.query,
            assignee: undefined,
          },
        };
      } else {
        this.organizationMembers.forEach((i) => (i.selected = false));
        member.selected = true;
        this.organizationTasksRequest = {
          ...this.organizationTasksRequest,
          query: {
            ...this.organizationTasksRequest.query,
            assignee: { value: member.accountId, isObject: true },
          },
        };
      }
    },
    /** TKP-165: sütun süzgeci yamasını iki isteğe uygular. */
    applyColumnFilter(patch, keys) {
      this.organizationTasksRequest = applyPatch(this.organizationTasksRequest, patch, keys);
      this.myTasksRequest = applyPatch(this.myTasksRequest, patch, keys);
    },
    openNewTaskModal() {
      this.$store.commit("task/showTaskCreateModal", true);
    },

    reloadAll() {
      this.paginateMyTasks();
      this.paginateOrganizationTasks();
    },

    //
    async download(item) {
      this.$store.commit("fileManager/addDownloadedFile", { file: item });
    },

    async downloadExcel() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        const payload = { organization: { _id: this.currentOrganization?._id, name: this.currentOrganization?.name } };
        payload.products = ["GDPR", "KVKK", "DDO", "BGYS", "PLATFORM"]; // TKP-165: ürün süzgeci yok, dışa aktarma tüm ürünler

        if (this.scope == "ACCOUNT") {
          delete payload.organization;
        }
        if (this.activeTab == "account") {
          payload.downloadScope = this.scope == "ACCOUNT" ? "ACCOUNT" : "ACCOUNT_IN_ORGANIZATION";
        } else if (this.activeTab == "organization") {
          payload.downloadScope = "ORGANIZATION";
        }
        payload.pagination = exportPagination(this.activeTab == "organization" ? this.organizationTasksRequest : this.myTasksRequest); // TKP-243 r.1

        const { data: file } = await this.$store.dispatch(`task/download`, payload);
        this.download(file);

        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        console.error(error);
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    /** TKP-239 g.9: adreste görev kimliği varsa (/tasks/:id, /account/tasks/:id) görev detayı açılır. */
    openTaskFromRoute() {
      const id = this.$route.params && this.$route.params.id;
      if (!id || !/^[0-9a-f]{24}$/i.test(String(id))) return;
      this.$store.commit("task/showTaskDetailModal", true);
      this.$store.dispatch("task/fetchDetail", id);
    },
    handleQueryParams() {
      const queryParams = this.$route.query;

      const safeStatuses = ["UNWORKED", "NOT_FIT", "TODO", "IN_PROGRESS", "APPROVAL", "DONE"];
      const safeViewTypes = ["list", "kanban"];
      const safeActiveTabs = ["account", "organization"];
      if (queryParams && queryParams.activeTab === "analytics") { this.$router.replace("/tasks/dashboard"); return; } // TKP-164: eski sekme adresi

      if (!queryParams) {
        return;
      }

      if (queryParams.viewType && safeViewTypes.includes(queryParams.viewType)) {
        this.viewType = queryParams.viewType;
      }

      if (queryParams.activeTab && safeActiveTabs.includes(queryParams.activeTab)) {
        this.activeTab = queryParams.activeTab;
      }
      if (queryParams.status && safeStatuses.includes(queryParams.status)) {
        this.statusFilter = queryParams.status;
      }
    },
    onSelect() {
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./tasks";

.archive-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 4.5rem;
  height: 2.5rem;
  border-radius: 0.625rem;
  border: 1px solid #e8eaed;
}
</style>
